<template>
    <div>
        <span>
            <label for="act-select">Act:</label>
        </span>
        <span>
            <select id="act-select" v-model="selectedOption" @change="emitSelection">
                <option value="1" selected>1</option>
                <option value="2" selected>2</option>
                <option value="3" selected>3</option>
            </select>
        </span>
    </div>
</template>

<script>
export default {
    name: 'ActSelectionDropdown',
    props: {
        initialValue: {
            type: String,
            default: '1',
        },
    },
    data() {
        return {
            selectedOption: this.initialValue,
        };
    },
    methods: {
        emitSelection() {
            // debug.... console.log('Selected option:', this.selectedOption);
            this.$emit('selection-changed', this.selectedOption);
        },
    },
    watch: {
        initialValue(newValue) {
            this.selectedOption = newValue;
        }
    }
};
</script>

<style scoped>
#act-select {
    padding: 8px 12px;
    border: 1px solid #ccc;
    border-radius: 4px;
    background-color: white;
    font-size: 1rem;
    color: #333;
    cursor: pointer;
    min-width: 30px;

    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
}

/* Style on focus */
#act-select:focus {
    outline: none;
    border-color: #007bff;
    /* Example focus color */
    box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
    /* Example focus shadow */
}

/* Style disabled option */
#act-select option[disabled] {
    color: #999;
}
</style>